/**
 * Cleans a string into a valid css selector for use as values for id, class, name attributes.
 * It decodes URI, removes special characters and replaces spaces with hyphens.
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cleanElementSelector',
    standalone: false
})
export class CleanElementSelectorPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    value = decodeURIComponent(value)
      .replace(/[^\w\s]/gi, '')
      .trim()
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
    return value;
  }

}
